import enMessages from "./message/en_US.json"
import zhMessages from "./message/zh_CN.json"

export const enUS = enMessages
export const zhCN = zhMessages